import React from 'react';

export const FilterControl = ({ desc, control }) => {
  return (
    <div style={{ display: 'flex', maxWidth: 680 }}>
      <div style={{ width: 220, padding: 5 }}>
        <label>{desc}</label>
      </div>
      <div style={{ flex: '1 1 auto' }}>{control}</div>
    </div>
  );
};
